import { ThemeConfig } from 'antd';
import variables from './variables';

const config: ThemeConfig = {
  token: {
    fontFamily: variables.fontFamily,
    colorText: variables.colorTextPrimary,
    colorPrimary: variables.colorPrimaryMain,
    colorLink: variables.colorPrimaryMain,
    colorError: variables.colorErrorMain,
    colorErrorBg: variables.colorErrorLight,
    colorSuccess: variables.colorSuccessMain,
    colorSuccessBg: variables.colorSuccessBg,
    colorInfo: variables.colorNeutralMain,
    colorInfoBg: variables.colorNeutralLight,
  },
  components: {
    Layout: {
      bodyBg: variables.colorWhite,
      siderBg: variables.colorWhite,
      headerBg: variables.colorWhite,
      footerBg: variables.colorWhite,
    },
    Button: {
      controlHeight: 40,
      borderRadius: 8,
      contentFontSize: 16,
      contentLineHeight: 1.4,
      fontWeight: 600,
      paddingInline: 12,
      paddingBlock: 8,
      opacityLoading: 1,
      defaultBorderColor: variables.colorPrimaryMain,
      defaultColor: variables.colorPrimaryMain,
      colorText: variables.colorPrimaryMain,
      colorLinkHover: variables.colorPrimaryMain,
      lineWidth: 2,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Input: {
      controlHeight: 40,
      colorBorder: variables.colorNeutralDark,
      borderRadius: 8,
    },
    InputNumber: {
      controlHeight: 40,
      colorBorder: variables.colorNeutralDark,
      borderRadius: 8,
    },
    Select: {
      controlHeight: 40,
      colorBorder: variables.colorNeutralDark,
      borderRadius: 8,
    },
    Divider: {
      colorSplit: variables.colorBorder,
    },
    Drawer: {
      marginSM: 0,
      padding: 12,
      paddingLG: 12,
      lineWidth: 0,
    },
    Card: {
      paddingLG: 0,
      borderRadiusLG: 12,
    },
    Popover: {
      sizePopupArrow: 0,
      borderRadius: 12,
      borderRadiusLG: 12,
    },
    Menu: {
      activeBarBorderWidth: 0,
      padding: 0,
      subMenuItemBg: 'transparent',
      itemColor: variables.colorTextPrimary,
      itemHoverColor: variables.colorTextPrimary,
      itemMarginBlock: 0,
      itemMarginInline: 0,
      itemHeight: 42,
      itemSelectedBg: variables.colorButtonBackground,
      itemSelectedColor: variables.colorPrimaryDark,
    },
    DatePicker: {
      controlHeight: 40,
      colorBorder: variables.colorNeutralDark,
      borderRadius: 8,
    },
    Carousel: {
      arrowOffset: -16,
    },
    Radio: {
      radioSize: 24,
      dotSize: 9,
      buttonCheckedBg: variables.colorPrimaryMain,
    },
    Checkbox: {
      colorBorder: variables.colorTextDisabled,
      borderRadiusSM: 2,
      lineWidth: 1,
    },
  },
};

export default config;
